export default __webpack_public_path__ + "assets/images/c46949a1abab3783064f68ea7666fb88.svg";